import { connectedAccountsStore } from '../store/store';
import { setConsumerMailbox } from '../services/setConsumerMailbox';
import { updateSessionSettings } from '../actions/defaultFrom/updateSessionSettings';
import { markIsConnectedAccountsDirty } from '../actions/connectedFull/markIsConnectedAccountsDirty';
import { markIsDefaultFromDirty } from '../actions/connectedFull/markIsDefaultFromDirty';
import { removeSyncRequest } from '../services/removeSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';

export async function onSaveConnectedAccountOption(): Promise<void> {
    let store = connectedAccountsStore();

    if (store.isDefaultFromDirty) {
        await setConsumerMailbox(store.defaultFromState.defaultFromAddress);
        updateSessionSettings(store.defaultFromState.defaultFromAddress);
        markIsDefaultFromDirty(false);
    }

    if (store.isConnectedAccountsDirty) {
        let index = 0;

        for (index = 0; index < store.accountsInfo.SyncRequests.length; index++) {
            let found = false;

            for (let account of store.accounts) {
                if (store.accountsInfo.SyncRequests[index].Id === account.syncRequest.Id) {
                    found = true;
                }
            }

            if (!found) {
                await removeSyncRequest(store.accountsInfo.SyncRequests[index]);
            }
        }

        await initConnectedAccountsFull();
        markIsConnectedAccountsDirty(false);
    }
}
